import {UserStorage} from '@fantasmagames/slot/src/logic/Storage';
import {IRecodeStorage} from '@fantasmagames/slot/src/integration/RecodeIntegrator';

export class ReCodeStorage extends UserStorage implements IRecodeStorage {
	private _APIReference: IRecodeStorage;

	constructor(apiReference: IRecodeStorage) {
		super();
		this.setStorageReference(apiReference);
	}

	public setItem(key: string, value: any): void {
		this._APIReference.setItem(key, value);
	}

	public getItem(item: string): any {
		return this._APIReference.getItem(item);
	}

	public getKey(key: number): any {
		return this._APIReference.getKey(key);
	}

	public removeItem(key: string): void {
		this._APIReference.removeItem(key);
	}

	public getLength(): number {
		return this._APIReference.getLength();
	}

	public hasItem(key: string): boolean {
		return this._APIReference.hasItem(key);
	}

	public each(): any {
		return this._APIReference.each;
	}

	public setStorageReference(VAPIStorage: IRecodeStorage): void {
		this._APIReference = VAPIStorage;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/integration/ReCodeStorage.ts